import { PROJECT_BRANDS } from '@/modules/brand/domain/brand';
import COMPONENT from '@/services/ui-component-names';

export const DOWNLOAD_APP_BY_BRAND = {
  [PROJECT_BRANDS.reverse]: COMPONENT.PAYMENT_DOWNLOAD_APP_V2,
  [PROJECT_BRANDS.muscleCharge]: COMPONENT.DOWNLOAD_APP,
};

export const resolveDownloadAppComponent = (brand) => DOWNLOAD_APP_BY_BRAND[brand] || COMPONENT.PAYMENT_DOWNLOAD_APP_V2;
